export const RESET = 'SPEAKER_UPDATE_RESET';
export const SET_ERROR = 'SPEAKER_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'SPEAKER_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'SPEAKER_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'SPEAKER_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'SPEAKER_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'SPEAKER_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/speaker/update/mutation_types.js